import { FC, useState } from 'react';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';

import ComponentButton from 'components/Button/ComponentButton';
import PanelSection from 'components/Slider/PanelSection';
import Popup from 'components/Slider/Popup';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentSingleInstance } from 'graphqlTypes';

type SliderProps = ContentfulComponentSingleInstance & {
  backgroundIsDark: boolean;
};

const Slider: FC<SliderProps> = ({ heading, body, backgroundIsDark }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState<number[]>([0, 0, 0]);

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="40px"
      sm={{ gap: '56px' }}
      lg={{ gap: '64px' }}
    >
      <Flex flexDirection="column" gap="16px" width="100%" maxWidth="770px" marginX="auto" textAlign="center">
        {heading && (
          <Heading
            as="h2"
            fontSize="h5"
            lineHeight="h5"
            fontWeight="bold"
            textColor={backgroundIsDark ? 'common-white' : 'gray-900'}
            sm={{ fontSize: 'h4', lineHeight: 'h4' }}
            lg={{ fontSize: 'h3', lineHeight: 'h3' }}
          >
            {heading}
          </Heading>
        )}
        {body && (
          <Flex flexDirection="column" gap="16px" textColor={backgroundIsDark ? 'common-white' : 'gray-700'}>
            {richTextParser(body)}
          </Flex>
        )}
      </Flex>
      <PanelSection setValues={value => setValues(value)} />
      <Flex width="100%" justifyContent="center" onClick={() => setIsOpen(true)}>
        <ComponentButton label="Calculate" isButton />
      </Flex>
      {isOpen && <Popup values={values} open={isOpen} onClose={() => setIsOpen(false)} />}
    </Flex>
  );
};

export default Slider;
